import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Editor, { HeadlineEditor } from '@contently/editor';
import styled from '@emotion/styled';
import { useResource } from 'rest-hooks';
import TextEditorAnnotations from './TextEditorAnnotations';
import useTextEditor from '../../hooks/useTextEditor';
import useStoryContext from '../../hooks/useStoryContext';
import ContentResource from '../../resources/ContentResource';

const PositionContainer = styled.div`
  position: relative;
`;

export default function TextEditor(props) {
  const positionContainerRef = useRef(null);
  const { id: storyId } = useStoryContext();
  const contents = useResource(ContentResource.listShape(), { contentable_id: storyId });
  const { historyMode, readOnlyMode, contentId, contentEditorId, format } = props;
  const { consumerApi, provider } = useTextEditor(
    contentEditorId,
    historyMode,
    readOnlyMode,
    format
  );

  if (!provider) return null;

  let editor;

  switch (format) {
    case 'headline':
      editor = (
        <HeadlineEditor
          onDispatchTransaction={() => {}}
          contentProvider={provider}
          consumerApi={consumerApi}
        />
      );
      break;
    default:
      editor = (
        <Editor
          onDispatchTransaction={() => {}}
          contentProvider={provider}
          consumerApi={consumerApi}
        />
      );
      break;
  }

  return (
    <PositionContainer ref={positionContainerRef}>
      <TextEditorAnnotations
        consumerApi={consumerApi}
        contentId={contentId}
        allContentIds={contents.map(c => parseInt(c.id, 10))}
        positionContainerRef={positionContainerRef}
      />
      {editor}
    </PositionContainer>
  );
}

TextEditor.defaultProps = {
  historyMode: false,
  readOnlyMode: false,
  format: 'rich'
};

TextEditor.propTypes = {
  contentId: PropTypes.number.isRequired,
  contentEditorId: PropTypes.string.isRequired,
  historyMode: PropTypes.bool,
  readOnlyMode: PropTypes.bool,
  format: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/TextEditor.jsx